import { Children, useEffect, useRef } from 'react';
import gsap from 'gsap';

import { Layout as PropsLayout } from '@/models/Props';

import { LGridSystem } from '@/components/layouts';

import './Timeline.scss';
import useLoaderStore from '@/stores/useLoaderStore';

const Timeline = ({ children }: PropsLayout) => {
    const timelineRef = useRef<HTMLElement>(null);

    const loading = useLoaderStore((state) => state.loading);

    useEffect(() => {
        if (!loading) {
            gsap.fromTo(
                timelineRef.current,
                {
                    y: 200,
                },
                { y: 0, duration: 0.5, ease: 'power2', delay: 0.8 }
            );
        }
    }, [loading]);

    return (
        <LGridSystem
            ref={timelineRef}
            sortChildren={'rows'}
            className={'timeline'}
        >
            <div className={'timeline__center'}></div>
            {Children.map(children, (child: any, idx) => {
                if (child?.props.section) {
                    const rightLine = idx % 2 === 0;
                    const lastChild = Children.count(children) === idx + 1;

                    return (
                        <div
                            key={idx}
                            data-grid={'active'}
                            data-grid-dir={'rows'}
                            className={'timeline__section'}
                            data-last={lastChild ? 'last' : ''}
                        >
                            <div
                                data-grid={'active'}
                                data-grid-dir={'columns'}
                                className={'timeline__lines'}
                                data-border-side={rightLine ? 'right' : 'left'}
                            >
                                <div data-border={'left'}></div>
                                <div data-border={'center'}></div>
                                <div data-border={'center'}></div>
                                <div data-border={'right'}></div>
                            </div>
                            {child}
                        </div>
                    );
                }
            })}
        </LGridSystem>
    );
};

export default Timeline;
